(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-loox-reviews-script"] && !Shopify.designMode) return;
  try {
    (function () {
    var LOOX_MODAL_SELECTORS = [
      '#looxReviews',
      '#looxReviewsModal',
      '#looxOverlay_looxModalFrame',
      '[id^="looxOverlay_"]',
      '#looxModalFrame',
      '.loox-lightbox',
      '.lxs-lightbox',
      '.loox-modal',
      '.loox-reviews-modal',
      '.loox-overlay',
      '.lxs-overlay',
      '[class*="loox"][class*="lightbox"]',
      '[class*="loox"][class*="modal"]',
      '[class*="loox"][class*="overlay"]',
      '[class*="lxs"][class*="modal"]',
      '[class*="lxs"][class*="overlay"]',
    ];
    var LOOX_TRIGGER_SELECTOR = '.bundle-reviews-loox-trigger, [id^="BundleLooxTrigger-"]';
    var LOOX_CLOSE_CONSECUTIVE = 3;
    var LOOX_WATCH_MAX_TICKS = 600;

    var looxWatchInterval = null;
    var looxMutationObserver = null;
    var looxEscapeHandler = null;
    var looxClickHandler = null;
    var looxModalActive = false;
    var looxActiveSectionId = null;
    var looxClosedStreak = 0;
    var looxWatchTicks = 0;

    function isInsideBundleLooxTrigger(node) {
      if (!node || typeof node.closest !== 'function') {
        return false;
      }

      return !!node.closest(LOOX_TRIGGER_SELECTOR);
    }

    function isVisibleLooxModalNode(node) {
      if (!node || isInsideBundleLooxTrigger(node)) {
        return false;
      }

      var style = window.getComputedStyle(node);

      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }

      if (parseFloat(style.opacity) <= 0) {
        return false;
      }

      var rect = node.getBoundingClientRect();

      return rect.width > 80 && rect.height > 80;
    }

    function setBundleHeaderHidden(hidden) {
      var root = document.documentElement;
      var sentinelId = 'bundle-loox-hide-header';
      var sentinel = document.getElementById(sentinelId);
      var siteHeader = document.querySelector('header');

      if (hidden) {
        root.classList.add('bundle-loox-modal-open');

        if (siteHeader) {
          siteHeader.style.transform = 'translateY(-100%)';
        }

        if (!sentinel) {
          sentinel = document.createElement('div');
          sentinel.id = sentinelId;
          sentinel.setAttribute('data-hide-header', '');
          sentinel.setAttribute('aria-hidden', 'true');
          sentinel.style.cssText =
            'position:fixed;top:0;left:0;width:100%;height:var(--header-height,120px);pointer-events:none;z-index:1;';
          document.body.appendChild(sentinel);
        }
      } else {
        root.classList.remove('bundle-loox-modal-open');

        if (siteHeader) {
          siteHeader.style.transform = '';
        }

        if (sentinel) {
          sentinel.remove();
        }
      }

      window.dispatchEvent(new Event('scroll'));
    }

    function getLooxClickTarget(sectionId) {
      var root = document.getElementById('BundleLooxTrigger-' + sectionId);

      if (!root) {
        return null;
      }

      var target = root.querySelector('.loox-trust-badge-widget-content-container');

      if (!target) {
        target = root.querySelector('.loox-trust-badge-container');
      }

      if (!target) {
        target = root.querySelector('[data-loox-open-reviews]');
      }

      return target;
    }

    function isLooxModalOpen() {
      if (
        document.body.classList.contains('loox-modal-open') ||
        document.documentElement.classList.contains('loox-modal-open')
      ) {
        return true;
      }

      for (var i = 0; i < LOOX_MODAL_SELECTORS.length; i++) {
        var nodes = document.querySelectorAll(LOOX_MODAL_SELECTORS[i]);

        for (var j = 0; j < nodes.length; j++) {
          if (isVisibleLooxModalNode(nodes[j])) {
            return true;
          }
        }
      }

      return false;
    }

    function stopLooxCloseWatch() {
      if (looxWatchInterval) {
        clearInterval(looxWatchInterval);
        looxWatchInterval = null;
      }

      if (looxMutationObserver) {
        looxMutationObserver.disconnect();
        looxMutationObserver = null;
      }

      if (looxEscapeHandler) {
        document.removeEventListener('keydown', looxEscapeHandler);
        looxEscapeHandler = null;
      }

      if (looxClickHandler) {
        document.removeEventListener('click', looxClickHandler, true);
        looxClickHandler = null;
      }

      looxWatchTicks = 0;
      looxClosedStreak = 0;
    }

    function closeLooxSession() {
      if (!looxModalActive && !document.documentElement.classList.contains('bundle-loox-modal-open')) {
        stopLooxCloseWatch();
        looxActiveSectionId = null;
        return;
      }

      looxModalActive = false;
      setBundleHeaderHidden(false);
      stopLooxCloseWatch();
      looxActiveSectionId = null;
    }

    function openLooxSession(sectionId) {
      looxModalActive = true;
      looxActiveSectionId = sectionId;
      looxClosedStreak = 0;
      looxWatchTicks = 0;
      setBundleHeaderHidden(true);
    }

    function handleLooxModalState() {
      looxWatchTicks = looxWatchTicks + 1;

      if (isLooxModalOpen()) {
        looxClosedStreak = 0;

        if (!looxModalActive) {
          openLooxSession(looxActiveSectionId);
        }

        return;
      }

      if (!looxModalActive) {
        return;
      }

      looxClosedStreak = looxClosedStreak + 1;

      if (looxClosedStreak >= LOOX_CLOSE_CONSECUTIVE) {
        closeLooxSession();
        return;
      }

      if (looxWatchTicks >= LOOX_WATCH_MAX_TICKS) {
        closeLooxSession();
      }
    }

    function scheduleLooxStateCheck(delayMs) {
      setTimeout(handleLooxModalState, delayMs || 0);
    }

    function scheduleLooxCloseAfterUserAction(delayMs) {
      setTimeout(function () {
        if (!isLooxModalOpen()) {
          closeLooxSession();
          return;
        }

        scheduleLooxStateCheck(0);
      }, delayMs || 200);
    }

    function isLooxOverlayElement(node) {
      if (!node || node.nodeType !== 1) {
        return false;
      }

      if (node.id && node.id.indexOf('looxOverlay_') === 0) {
        return true;
      }

      if (node.classList && node.classList.contains('loox-overlay')) {
        return true;
      }

      return false;
    }

    function bindLooxOverlayElement(overlay) {
      if (!overlay || overlay.dataset.bundleLooxBound === 'true') {
        return;
      }

      overlay.dataset.bundleLooxBound = 'true';

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          scheduleLooxCloseAfterUserAction(400);
        }
      });
    }

    function bindAllLooxOverlays() {
      var overlays = document.querySelectorAll('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]');

      for (var i = 0; i < overlays.length; i++) {
        bindLooxOverlayElement(overlays[i]);
      }
    }

    function onLooxDomMutation(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'childList') {
          if (mutation.addedNodes) {
            for (var a = 0; a < mutation.addedNodes.length; a++) {
              var added = mutation.addedNodes[a];

              if (isLooxOverlayElement(added)) {
                bindLooxOverlayElement(added);
              }

              if (added && added.querySelectorAll) {
                var nestedOverlays = added.querySelectorAll('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]');

                for (var n = 0; n < nestedOverlays.length; n++) {
                  bindLooxOverlayElement(nestedOverlays[n]);
                }
              }
            }
          }

          if (mutation.removedNodes && looxModalActive) {
            for (var r = 0; r < mutation.removedNodes.length; r++) {
              if (isLooxOverlayElement(mutation.removedNodes[r])) {
                closeLooxSession();
                return;
              }
            }
          }
        }

        if (mutation.type === 'attributes' && mutation.target && isLooxOverlayElement(mutation.target)) {
          var overlayStyle = window.getComputedStyle(mutation.target);

          if (
            overlayStyle.display === 'none' ||
            overlayStyle.visibility === 'hidden' ||
            parseFloat(overlayStyle.opacity) <= 0
          ) {
            scheduleLooxCloseAfterUserAction(450);
          }
        }
      }

      bindAllLooxOverlays();
      scheduleLooxStateCheck(0);
    }

    function startLooxCloseWatch(sectionId) {
      stopLooxCloseWatch();
      looxActiveSectionId = sectionId;
      looxClosedStreak = 0;
      looxWatchTicks = 0;

      bindAllLooxOverlays();

      looxWatchInterval = setInterval(handleLooxModalState, 100);

      looxMutationObserver = new MutationObserver(onLooxDomMutation);
      looxMutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'opacity'],
      });

      looxEscapeHandler = function (event) {
        if (event.key !== 'Escape' || !looxModalActive) {
          return;
        }

        scheduleLooxCloseAfterUserAction(400);
      };

      looxClickHandler = function (event) {
        var target = event.target;

        if (!target || typeof target.closest !== 'function') {
          return;
        }

        if (
          target.closest(
            '#close-button, .hcp-modal-header-close-button, .loox-close, .lxs-close, [data-loox-close], [class*="loox"][class*="close"], [class*="lxs"][class*="close"], [aria-label="Close"], [aria-label*="close" i]',
          )
        ) {
          scheduleLooxCloseAfterUserAction(400);
          return;
        }

        if (target.closest('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]')) {
          var overlay = target.closest('[id^="looxOverlay_"], .loox-overlay[aria-modal="true"]');

          if (overlay && target === overlay) {
            scheduleLooxCloseAfterUserAction(400);
          }
        }
      };

      document.addEventListener('keydown', looxEscapeHandler);
      document.addEventListener('click', looxClickHandler, true);
    }

    function triggerLooxOpen(sectionId) {
      var target = getLooxClickTarget(sectionId);

      if (target && typeof target.click === 'function') {
        target.click();
        return true;
      }

      if (window.loox && typeof window.loox.openReviews === 'function') {
        window.loox.openReviews();
        return true;
      }

      if (window.Loox && typeof window.Loox.openReviewModal === 'function') {
        window.Loox.openReviewModal();
        return true;
      }

      var pageTrigger = document.querySelector(
        '.loox-trust-badge-widget-content-container, .loox-trust-badge-container[data-loox-open-reviews], [data-loox-open-reviews=true]',
      );

      if (pageTrigger && typeof pageTrigger.click === 'function') {
        pageTrigger.click();
        return true;
      }

      return false;
    }

    function waitForLooxModal(sectionId) {
      var ticks = 0;

      var timer = setInterval(function () {
        ticks = ticks + 1;

        if (isLooxModalOpen()) {
          clearInterval(timer);
          openLooxSession(sectionId);
          startLooxCloseWatch(sectionId);
          return;
        }

        if (ticks > 60) {
          clearInterval(timer);
          closeLooxSession();
        }
      }, 100);
    }

    function preloadLooxForSection(sectionId) {
      if (!window.bundleLooxPreloaded) {
        window.bundleLooxPreloaded = {};
      }

      if (window.bundleLooxPreloaded[sectionId]) {
        return;
      }

      var ticks = 0;

      var timer = setInterval(function () {
        ticks = ticks + 1;
        var target = getLooxClickTarget(sectionId);

        if (target || window.loox || window.Loox || ticks > 40) {
          clearInterval(timer);
          window.bundleLooxPreloaded[sectionId] = !!target;
        }
      }, 250);
    }

    function preloadAllBundleLooxTriggers() {
      var triggers = document.querySelectorAll('[id^="BundleLooxTrigger-"]');

      for (var i = 0; i < triggers.length; i++) {
        var sectionId = triggers[i].id.replace('BundleLooxTrigger-', '');
        preloadLooxForSection(sectionId);
      }
    }

    function openLooxPopup(sectionId) {
      var attempts = 0;

      if (looxModalActive) {
        closeLooxSession();
      }

      looxActiveSectionId = sectionId;

      function tryOpen() {
        attempts = attempts + 1;

        if (triggerLooxOpen(sectionId)) {
          waitForLooxModal(sectionId);
          return;
        }

        if (attempts < 15) {
          setTimeout(tryOpen, 200);
          return;
        }

        closeLooxSession();
      }

      tryOpen();
    }

    window.openBundleLooxReviews = openLooxPopup;
    window.bundleLooxPreloaded = window.bundleLooxPreloaded || {};

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preloadAllBundleLooxTriggers);
    } else {
      preloadAllBundleLooxTriggers();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookt-loading-overlay"] && !Shopify.designMode) return;
  try {
    window.CooktLoadingOverlay = (function () {
    const MEAL_PHOTOS = [
      'https://cdn.shopify.com/s/files/1/0916/8915/6918/files/0b005050-e3a1-4bb4-a948-c3b88863bf1e.png?v=1780690504&width=360',
      'https://cdn.shopify.com/s/files/1/0916/8915/6918/files/9bebb39d-7d9d-4de7-b727-05d002a95dc2.png?v=1780691952&width=360',
      'https://cdn.shopify.com/s/files/1/0916/8915/6918/files/ChatGPTImageJun5_2026at04_09_11PM_5.png?v=1780690326&width=360',
      'https://cdn.shopify.com/s/files/1/0916/8915/6918/files/ChatGPTImageJun5_2026at04_09_12PM_7_36803d74-1198-40d7-ab5c-722584778066.png?v=1780690365&width=360',
      'https://cdn.shopify.com/s/files/1/0916/8915/6918/files/0f7c504c-24ef-4203-9e0f-45fdacb94cde.png?v=1780690205&width=360',
      'https://cdn.shopify.com/s/files/1/0916/8915/6918/files/c101136f-2baf-4c64-a429-9c3a913e2b66.png?v=1780691707&width=360'
    ];
    const MESSAGES = JSON.parse(document.getElementById('ck-overlay').dataset.messages || '[]');
    const MESSAGE_INTERVAL = 900;
    const PER_PHOTO = 2.8;
    let msgTimer = null;
    let built = false;
    let visible = false;
    let msgIdx = 0;

    function clearTimers() {
      clearInterval(msgTimer);
      msgTimer = null;
    }

    function buildPhotos() {
      if (built) {
        return;
      }

      built = true;
      const plate = document.getElementById('ck-plate');
      const cycle = PER_PHOTO * MEAL_PHOTOS.length;

      MEAL_PHOTOS.forEach(function (src, i) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.style.animation =
          'ck-photo-cycle ' + cycle + 's ease-in-out ' + (i * PER_PHOTO) + 's infinite, ' +
          'ck-photo-zoom ' + cycle + 's linear ' + (i * PER_PHOTO) + 's infinite';
        plate.appendChild(img);
      });
    }

    function setMessage(text, withEnter) {
      const msgEl = document.getElementById('ck-message-text');

      if (!msgEl) {
        return;
      }

      msgEl.classList.remove('is-entering', 'is-fading');

      if (withEnter) {
        msgEl.textContent = text;
        void msgEl.offsetWidth;
        msgEl.classList.add('is-entering');
        return;
      }

      msgEl.classList.add('is-fading');

      window.setTimeout(function () {
        const current = document.getElementById('ck-message-text');

        if (!current) {
          return;
        }

        current.textContent = text;
        current.classList.remove('is-fading');
      }, 220);
    }

    function startMessageCycle() {
      clearTimers();
      msgIdx = 0;

      if (!MESSAGES.length) {
        return;
      }

      setMessage(MESSAGES[0], true);

      if (MESSAGES.length < 2) {
        return;
      }

      msgTimer = setInterval(function () {
        if (msgIdx >= MESSAGES.length - 1) {
          clearTimers();
          return;
        }

        msgIdx += 1;
        setMessage(MESSAGES[msgIdx], false);
      }, MESSAGE_INTERVAL);
    }

    function show() {
      const overlay = document.getElementById('ck-overlay');

      buildPhotos();

      if (visible || (overlay && overlay.classList.contains('is-visible'))) {
        visible = true;
        return;
      }

      visible = true;
      overlay.classList.add('is-visible');
      startMessageCycle();
    }

    function redirect(url) {
      clearTimers();
      window.location.href = url || '/checkout';
    }

    function hide() {
      clearTimers();
      visible = false;
      document.getElementById('ck-overlay').classList.remove('is-visible');
    }

    MEAL_PHOTOS.forEach(function (src) {
      new Image().src = src;
    });

    return { show: show, hide: hide, redirect: redirect };
  })();
  } catch(e) { console.error(e); }
})();

})();
